/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./wxgame-form.vue?vue&type=template&id=5c0c81c2&scoped=true&"
import script from "./wxgame-form.vue?vue&type=script&lang=ts&"
export * from "./wxgame-form.vue?vue&type=script&lang=ts&"
import style0 from "./wxgame-form.vue?vue&type=style&index=0&id=5c0c81c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c81c2",
  null
  
)

export default component.exports